import { __awaiter, __generator } from "tslib";
import { Ray } from "@babylonjs/core/Culling/ray";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { InteractorManager } from "../../core/tool/InteractorManager";
import { getDataPath, Log } from "../../utils";
import { loadContentAsBlobUrl } from "../../utils/dom";
import { joinPath } from "../../utils/string";
import { Interactor } from "./Interactor";
var Interactors = /** @class */ (function () {
    function Interactors(pArticle, pManager) {
        var _this = this;
        this.onInstantVisibilityCheck = function () {
            _this.mVisCheckTimeout = null;
            var tTime = Date.now();
            _this.checkInteractorVisibilities();
            var tElapsedTime = Date.now() - tTime;
            //disable instant check if performance is bad
            if (tElapsedTime > 50)
                _this.mInstantVisCheck = false;
        };
        this.onVisibilityCheck = function () {
            _this.mVisCheckTimeout = null;
            _this.checkInteractorVisibilities();
        };
        this.pickPredicate = function (pMesh) {
            return (pMesh != null && pMesh[Interactors.PICKING_ID] === _this.mCurrentPickingId);
        };
        this.mMngr = pManager;
        this.mArticle = pArticle;
        this.mInteractors = new InteractorManager(this.mMngr.app.viewer);
        this.mGetInteractorsPromise = null;
        this.mVisCheckTimeout = null;
        this.mDisableRequestVisCheck = false;
        this.mCurrentPickingId = null;
        this.mInstantVisCheck = true;
    }
    Object.defineProperty(Interactors.prototype, "manager", {
        get: function () {
            return (this.mMngr);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interactors.prototype, "article", {
        get: function () {
            return (this.mArticle);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interactors.prototype, "spriteUrl", {
        get: function () {
            return (Interactors.sSpriteUrl);
        },
        enumerable: false,
        configurable: true
    });
    Interactors.prototype.showInteractors = function (pShow) {
        var _this = this;
        this.clear();
        this.mInteractors.enabled = pShow;
        if (!this.mInteractors.enabled || this.mGetInteractorsPromise != null)
            return;
        if (this.mMngr.app.model.selection.length > 1)
            return;
        this.mGetInteractorsPromise = this.getAndCreateInteractors().then(function () {
            _this.mGetInteractorsPromise = null;
        }).catch(function (pError) {
            _this.mGetInteractorsPromise = null;
            Log.error("Failed to get oap interactors.", pError);
        });
    };
    Interactors.prototype.dispose = function () {
        this.clearVisCheckTimeout();
        this.mInteractors.dispose();
    };
    /** @internal */
    Interactors.prototype._requestVisibilityCheck = function (pInteractor) {
        if (this.mDisableRequestVisCheck)
            return;
        if (this.mInstantVisCheck) {
            if (this.mVisCheckTimeout == null)
                this.mVisCheckTimeout = window.setTimeout(this.onInstantVisibilityCheck, 0);
        }
        else {
            this.clearVisCheckTimeout();
            this.mVisCheckTimeout = window.setTimeout(this.onVisibilityCheck, 200);
        }
    };
    Interactors.PrepareSprite = function (pDataPath) {
        return __awaiter(this, void 0, void 0, function () {
            var IsUnsupportedIOS, tSpritePath, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(Interactors.sSpriteUrl == null)) return [3 /*break*/, 3];
                        IsUnsupportedIOS = function () {
                            //TODO: maybe create utils function for this
                            if (/iP(hone|od|ad)/.test(navigator.platform)) {
                                var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                                if (v == null) {
                                    return (false);
                                }
                                var tVersion = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || "0", 10)];
                                return (tVersion[0] < 12 || (tVersion[0] === 12 && tVersion[1] < 2));
                            }
                            return (false);
                        };
                        tSpritePath = joinPath(pDataPath, "cf/images/oap_sprite_v4.svg");
                        if (!IsUnsupportedIOS()) return [3 /*break*/, 1];
                        Interactors.sSpriteUrl = tSpritePath;
                        return [3 /*break*/, 3];
                    case 1:
                        _a = Interactors;
                        return [4 /*yield*/, loadContentAsBlobUrl(tSpritePath)];
                    case 2:
                        _a.sSpriteUrl = _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Interactors.prototype.clear = function () {
        this.clearVisCheckTimeout();
        this.mInstantVisCheck = true;
        this.mCurrentPickingId = null;
        this.mInteractors.clear();
        this.mInteractors.enabled = false;
    };
    Interactors.prototype.clearVisCheckTimeout = function () {
        if (this.mVisCheckTimeout != null) {
            clearTimeout(this.mVisCheckTimeout);
            this.mVisCheckTimeout = null;
        }
    };
    Interactors.prototype.getAndCreateInteractors = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tInteractors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Interactors.PrepareSprite(getDataPath())];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.mArticle.getMainArticle()._getOapInteractors(this.mArticle)];
                    case 2:
                        tInteractors = _a.sent();
                        //interactors were disabled while processing the asynchronous request
                        if (!this.mInteractors.enabled)
                            return [2 /*return*/];
                        this.createInteractors(tInteractors);
                        return [2 /*return*/];
                }
            });
        });
    };
    Interactors.prototype.createInteractors = function (pOapInteractors) {
        if (pOapInteractors == null)
            return;
        var tNeedVisCheck = false;
        for (var _i = 0, pOapInteractors_1 = pOapInteractors; _i < pOapInteractors_1.length; _i++) {
            var tOapInteractor = pOapInteractors_1[_i];
            //one interactor per symbol
            if (tOapInteractor.symbols != null && tOapInteractor.symbols.length > 0) {
                for (var _a = 0, _b = tOapInteractor.symbols; _a < _b.length; _a++) {
                    var tSymbol = _b[_a];
                    var tHiddenMode = this.createInteractor(tOapInteractor, tSymbol);
                    tNeedVisCheck = tNeedVisCheck || tHiddenMode;
                }
            }
            else {
                var tHiddenMode = this.createInteractor(tOapInteractor);
                tNeedVisCheck = tNeedVisCheck || tHiddenMode;
            }
        }
        //prepare visibility check
        if (tNeedVisCheck) {
            this.mCurrentPickingId = Interactors.sPickingIDCounter++;
            var tNodes = this.mArticle.getMainArticle().getNodes(true);
            for (var _c = 0, tNodes_1 = tNodes; _c < tNodes_1.length; _c++) {
                var tNode = tNodes_1[_c];
                if (tNode instanceof Mesh && tNode.geometry != null &&
                    tNode.isPickable && tNode.isVisible && tNode.isEnabled()) {
                    tNode[Interactors.PICKING_ID] = this.mCurrentPickingId;
                }
            }
        }
    };
    //returns true if interactor uses hidden mode
    Interactors.prototype.createInteractor = function (pOapInteractor, pOapSymbol) {
        var tInteractor = new Interactor(this, pOapInteractor, pOapSymbol);
        this.mInteractors.addInteractor(tInteractor);
        return (tInteractor.hiddenMode);
    };
    Interactors.prototype.checkInteractorVisibilities = function () {
        this.mDisableRequestVisCheck = true; //prevent recursive calls
        for (var _i = 0, _a = this.mInteractors.interactors; _i < _a.length; _i++) {
            var tInter = _a[_i];
            var tInteractor = tInter;
            if (!tInteractor.hiddenMode)
                continue;
            this.checkInteractorVisibility(tInteractor);
        }
        this.mDisableRequestVisCheck = false;
    };
    Interactors.prototype.checkInteractorVisibility = function (pInteractor) {
        if (this.mInteractors.view == null)
            return;
        var tCameraVec = Interactor._GetDirectionToCamera(pInteractor.worldPosition, this.mInteractors.view);
        var tRay = new Ray(pInteractor.worldPosition, tCameraVec);
        var tResult = this.mInteractors.viewer.scene.pickWithRay(tRay, this.pickPredicate, true);
        pInteractor.setHidden(tResult != null && tResult.hit);
    };
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    Interactors.sSpriteUrl = null;
    //// private ///////////////////////////////////////////////////////////////////////////////
    Interactors.PICKING_ID = "cf.OAPInteractors.pickingId";
    Interactors.sPickingIDCounter = 0;
    return Interactors;
}());
export { Interactors };
